import React, { useState, useRef, useEffect } from "react";
import {
  DropDownWrapper,
  DropDownButton,
  SVG,
  OptionMenu,
  OptionRow,
  Label,
} from "./CreditMenu.styles";

export function CreditMenu({
  defaultText = "",
  options = [],
  changeOptionName,
}) {
  const [actionDropDown, setActionDropDown] = useState(false);
  const dropdownEl = useRef(null);

  const dropdown = () => {
    setActionDropDown(!actionDropDown);
  };

  const handleClickClose = (event) => {
    const path = event.composedPath();

    let isClickInside = path.find((element) => element === dropdownEl.current);

    if (isClickInside === undefined) {
      if (actionDropDown) {
        setActionDropDown(false);
      }
    }
  };

  useEffect(() => {
    document.addEventListener("mouseup", handleClickClose);
    return () => {
      document.removeEventListener("mouseup", handleClickClose);
    };
  });

  return (
    <DropDownWrapper>
      <div ref={dropdownEl}>
        <DropDownButton onClick={dropdown} actionDropDown={actionDropDown}>
          {defaultText}
          <SVG>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </SVG>
        </DropDownButton>

        <DropDownWrapper>
          {actionDropDown ? (
            <>
              <OptionMenu role="menu">
                {options.map((option, key) => (
                  <OptionRow>
                    <div>
                      <Label>
                        {`${option.title}`}{" "}
                        <span title={option.tooltip} tabIndex="0">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <rect
                              width="16"
                              height="16"
                              rx="8"
                              fill="#E5E5EA"
                            />
                            <path
                              d="M8 12.25V7.25H7"
                              stroke="#8E8E93"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M7.749 3.25C7.611 3.25 7.499 3.362 7.5 3.5C7.5 3.638 7.612 3.75 7.75 3.75C7.888 3.75 8 3.638 8 3.5C8 3.362 7.888 3.25 7.749 3.25"
                              stroke="#8E8E93"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>
                      </Label>
                      <div className="price-holder">
                        <span className="unicode-plain">{option.credit}</span> تومان
                      </div>
                    </div>
                  </OptionRow>
                ))}
              </OptionMenu>
            </>
          ) : null}
        </DropDownWrapper>
      </div>
    </DropDownWrapper>
  );
}
